<template>
  <div>
    <b-modal
      id="modal-center"
      v-model="senderModal"
      hide-footer
      centered
      @hide="onClose"
    >
      <p class="my-1">
        {{ $t('send_in_other_ways') }}
      </p>
      <div class="text-center my-2">
        <b-dropdown
          id="dropdown-send-method"
          :text="selectedType ? $t(getSelectedLabelKey()) : $t('select_send_method')"
          variant="outline-primary"
          class="mr-1"
        >
          <b-dropdown-item @click="onSendType('telegram')">
            <BIconTelegram class="mr-2" />
            {{ $t('send_method_telegram') }}
          </b-dropdown-item>
          <b-dropdown-item @click="onSendType('whatsapp')">
            <BIconWhatsapp class="mr-2" />
            {{ $t('send_method_whatsapp') }}
          </b-dropdown-item>
          <b-dropdown-item @click="onSendType('sms')">
            <BIconChatText class="mr-2" />
            {{ $t('send_method_sms') }}
          </b-dropdown-item>
          <b-dropdown-item @click="onSendType('email')">
            <BIconEnvelope class="mr-2" />
            {{ $t('send_method_email') }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="text-center my-2">
        <b-button
          variant="primary"
          class="mt-2 w-100"
          :disabled="!selectedType"
          @click="onSubmit"
        >
          {{ $t('submit') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import otpSenderWaysModal from '@/views/logics/components/otpSenderWaysModal'

export default {
  mixins: [otpSenderWaysModal],
  methods: {
    getSelectedLabelKey() {
      const labelKeys = {
        telegram: 'send_method_telegram',
        whatsapp: 'send_method_whatsapp',
        sms: 'send_method_sms',
        email: 'send_method_email',
      }
      return labelKeys[this.selectedType] || this.selectedType
    },
  },
}
</script>

<style scoped>
.selected-type-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: #d4edda;
  color: #155724;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  margin-left: 0.5rem;
}
</style>